/**
 * Entidade Client (Cliente).
 * Referencia User por user_id.
 */

import { z } from 'zod';
import { UserRef } from '../user/entity';

export const clientSchema = z.object({
  id: z.string().min(1),
  user_id: z.string().min(1),
  name: z.string().min(1),
  phone: z.string().min(1),
  address: z.string().nullable(),
  reference: z.string().nullable(),
  notes: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Client = z.infer<typeof clientSchema>;

/** Referências Firestore da entidade Client (paths e strings centralizadas). */
export class ClientRef {
  static readonly collection = 'clients';
  static collectionPath(userId: string): string {
    const userPath = UserRef.docPath(userId);
    return `${userPath}/${this.collection}`;
  }
  static docPath(userId: string, id: string): string {
    const collectionPath = this.collectionPath(userId);
    return `${collectionPath}/${id}`;
  }
}
